module.exports = __webpack_public_path__ + "img/niupai.f5ab521d.png";